var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "DefaultContentLayout",
        [
          _c(
            "div",
            [
              _c("ClientFilters", {
                attrs: {
                  currentUserId: _vm.currentUser.id,
                  currentUserRole: _vm.currentUser.role,
                  filters: _vm.projectFilters,
                  hideContractorsFilter: "",
                  hideBudgetFilter: "",
                },
                on: {
                  filtersChanged: _vm.updateFilters,
                  filtersReset: _vm.resetFilters,
                },
              }),
              _c(
                "h1",
                {
                  staticClass:
                    "font-semibold font-outfit leading-10 project-count mb-3",
                },
                [_vm._v(" " + _vm._s(_vm.totalVisits) + " Open visits ")]
              ),
            ],
            1
          ),
          _c(
            "LoadingOverlay",
            {
              attrs: {
                hasData: _vm.hasData,
                loading: _vm.isLoading,
                spinnerCentered: "",
              },
            },
            [
              _vm.empty
                ? _c(
                    "EmptyListPlaceholder",
                    {
                      attrs: { title: _vm.emptyListPlaceholder, subtitle: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "image",
                            fn: function () {
                              return [_c("EmptyListImageProjects")]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        4049957145
                      ),
                    },
                    [
                      _c("UIButton", {
                        staticClass: "font-outfit",
                        attrs: {
                          variant: "black",
                          buttonText: "Create New Visit",
                          size: "lg",
                        },
                        on: { click: _vm.openActivityModal },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "icon",
                              fn: function () {
                                return [
                                  _c("PlusIcon", { staticClass: "w-4 h-4" }),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "hover-icon",
                              fn: function () {
                                return [
                                  _c("HoveredIcon", { staticClass: "w-6 h-6" }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          3681370335
                        ),
                      }),
                    ],
                    1
                  )
                : [
                    _c("VisitsCardWrapper", {
                      attrs: {
                        activities: _vm.activities,
                        currentUser: _vm.currentUser,
                        companyId: _vm.company.id,
                        getDeclinedMatchesForActivity:
                          _vm.getDeclinedMatchesForActivity,
                        getBookmarkedContractorsForActivity:
                          _vm.getBookmarkedContractorsForActivity,
                      },
                      on: {
                        visitUpdated: _vm.refetchVisits,
                        projectUpdated: _vm.refetchVisits,
                        openActivityModal: _vm.handleOpenActivityModal,
                      },
                    }),
                    _c("CardPagination", {
                      attrs: { config: _vm.paginationConfig },
                      on: {
                        "update:config": function ($event) {
                          _vm.paginationConfig = $event
                        },
                      },
                    }),
                  ],
            ],
            2
          ),
        ],
        1
      ),
      _vm.activityModalOpened
        ? _c("ActivityFormModal", {
            attrs: {
              currentUserRole: _vm.currentUser.role,
              companyId: _vm.company.id,
              currentUserId: _vm.currentUser.id,
              showProject: true,
              projectActivity: _vm.selectedActivity,
              suggestedAssignee: _vm.suggestedAssignee,
            },
            on: {
              activityUpdated: _vm.onActivityListItemAdded,
              activityAdded: _vm.onActivityListItemAdded,
              close: _vm.closeActivityModal,
            },
            model: {
              value: _vm.activityModalOpened,
              callback: function ($$v) {
                _vm.activityModalOpened = $$v
              },
              expression: "activityModalOpened",
            },
          })
        : _vm._e(),
      _c("router-view", {
        attrs: {
          company: _vm.company,
          currentUser: _vm.currentUser,
          totalVisits: "",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }